import React, { useState, useContext, useEffect } from 'react'
import { Timeline } from './Timeline'
import { LoadingCover } from '../commons/LoadingCover'
import { SystemError } from '../error/SystemError'
import { ProfileHeader } from './ProfileHeader'
import { useRouter } from 'next/router'
import Linkify from 'linkify-react'
import { UserContext } from '../../context/UserContext'
import { RateService } from './RateService'
import { openModal } from '../../service/modal-service'
import { motion } from 'framer-motion'
import { Image as ImageIcon, Newspaper, Megaphone, Users, Star, ChevronRight } from 'lucide-react'
import Link from 'next/link'

export const Profile = (props) => {
    const about = props.about;
    const stringHandleName = props.stringHandleName
    const stringsUserId = props.stringsUserId
    const profilePicture = props.profilePicture
    const timeline = props.timeline
    const router = useRouter()

    const [ isShowRateService, setIsShowRateService ] = useState(false)
    const [ isLoading, setIsLoading ] = useState(false);
    const [ isSystemError, setIsSystemError ] = useState(false);
    const [ errorContent, setErrorContent ]  = useState({'header': "", 'body': ""}); 

    const { userId } = useContext(UserContext)

    const options = {
        target: "_blank",
        className: "text-orange-600 hover:underline",
        rel: "noopener nofollow noreferrer"
    }

    const changeRoute = (path) => {
        // setIsLoading(true)
        router.push(path).then(() => setIsLoading(false))
    }

    const rateService = () => {
        if(!userId){
            changeRoute("/signin?redirect=" + router.asPath)
            return
        }
        openModal(setIsShowRateService)
    }

    const navigationItems = [
        { 
            label: 'Photos', 
            icon: ImageIcon, 
            path: `/profile/${stringHandleName}/photos`,
            color: 'bg-purple-100 text-purple-600'
        },
        // ...(about.userAccountType === "Professional" ? [{
        //     label: 'Listings', 
        //     icon: Megaphone, 
        //     path: `/profile/${stringHandleName}/listings/${about.category}`,
        //     color: 'bg-orange-100 text-orange-600'
        // }] : []),
        { 
            label: 'Posts', 
            icon: Newspaper, 
            path: `/profile/${stringHandleName}/posts`,
            color: 'bg-blue-100 text-blue-600'
        },
        { 
            label: 'Strings', 
            icon: Users, 
            path: `/profile/${stringHandleName}/strings`,
            color: 'bg-green-100 text-green-600'
        },
    ]

  return (
    <div className="bg-gray-50 min-h-screen">
        {/* Timeline/Cover Photo */}
        <Timeline stringsUserId={stringsUserId} timeline={timeline}/>        
        
        {/* Profile Header */}
        <ProfileHeader about={about} stringsUserId={stringsUserId} profilePicture={profilePicture} stringHandleName={stringHandleName}/>
        
        {/* Quick Navigation */}
        <div className='px-4 py-3'>
            <div className='bg-white rounded-2xl shadow-sm border border-gray-100 p-2'>
                <div className='flex justify-around gap-2'>
                    {navigationItems.map((item, index) => (
                        <Link key={item.label} href={item.path} className='flex flex-col items-center gap-1 p-3 rounded-xl hover:bg-gray-50 transition-colors'>                       
                            <div className={`p-2.5 rounded-xl ${item.color}`}>
                                <item.icon size={20} />
                            </div>
                            <span className='text-xs font-medium text-gray-600'>{item.label}</span>
                        </Link>
                    ))}
                </div>
            </div>
        </div>
        
        {/* About Section */}
        {about.description && (
            <div className='px-4 pb-4'>
                <motion.div 
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    className='bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden'
                >
                    <div className='px-4 py-3 border-b border-gray-100'>
                        <h2 className='font-semibold text-gray-900'>About</h2>
                    </div>
                    <div className='p-4'>
                        <Linkify as="p" options={options}                    
                            className='text-gray-600 wrap-break-word whitespace-pre-wrap text-sm leading-relaxed'>
                            {about.description}
                        </Linkify>
                    </div>
                </motion.div>
            </div>
        )}

        {/* Rate Service Button for Professionals */}
        {(about.userAccountType === "Professional" || about.userAccountType === "Employee") && (
            <div className='px-4 pb-24'>
                <motion.button 
                    whileTap={{ scale: 0.98 }}
                    onClick={rateService}
                    className='w-full flex items-center justify-center gap-2 py-4 bg-linear-to-r from-orange-500 to-amber-500 text-white font-semibold rounded-2xl shadow-lg shadow-orange-500/25 hover:shadow-xl hover:shadow-orange-500/30 transition-all'
                >
                    <Star size={20} />
                    Rate Service
                    <ChevronRight size={18} />
                </motion.button>
            </div>
        )}

        {/* Rate Service Modal */}
        {isShowRateService && (
            <RateService stringsUserId={stringsUserId} about={about} />
        )} 
        
        {isLoading && <LoadingCover/>}
        {isSystemError && <SystemError errorContent={errorContent} setIsSystemError={setIsSystemError}/>}
    </div>
  )
}
